module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"andXMore":"and {count} more"},"de":{"andXMore":"und {count} weitere"},"fr":{"andXMore":"et {count} plus encore"},"it":{"andXMore":"e {count} altri"}}')
  delete Component.options._Ctor
}
